export enum OperationType {
  ADD,
  EDIT,
  SAVE,
  DELETE,
  CLOSE,
  DISABLE,
  RELOAD,
}
